import type { DashCustomizationValue } from './DashCustomizationSection';

// Hosts de app da dash atual (headers Deeplinking-Host / TerminalPayment-Host
// que o useApp.ts guarda no localStorage). A dash nova ganha tema próprio, mas
// continua usando o app da dash de origem nos QR codes.
export interface DashCustomizationAppHosts {
  deeplinking_host?: string | null;
  terminal_payment_host?: string | null;
}

export interface DashCustomizationPayload extends DashCustomizationValue {
  deeplinking_host?: string;
  terminal_payment_host?: string;
}

/**
 * Monta a chave `dash_customization` do payload de /tenants/provisioning/auto.
 *
 * Retorna `undefined` (chave ausente no payload) quando nenhum campo foi
 * preenchido — o backend trata ausência e `null` da mesma forma (segue o fluxo
 * normal do autotenant). Decide pelos dados e não pelo toggle: recolher a seção
 * depois de preencher não pode descartar a personalização em silêncio.
 */
export function buildDashCustomizationPayload(
  dashCustomization: DashCustomizationValue,
  useSamePrimaryColor: boolean,
  appHosts: DashCustomizationAppHosts = {},
): DashCustomizationPayload | undefined {
  const isFilled = Object.values(dashCustomization).some((value) => !!value);
  if (!isFilled) return undefined;

  const payload: DashCustomizationPayload = {
    ...dashCustomization,
    secondary_color: useSamePrimaryColor
      ? dashCustomization.primary_color
      : dashCustomization.secondary_color,
  };

  if (appHosts.deeplinking_host) {
    payload.deeplinking_host = appHosts.deeplinking_host;
  }

  if (appHosts.terminal_payment_host) {
    payload.terminal_payment_host = appHosts.terminal_payment_host;
  }

  return payload;
}
